import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import { useTranslation } from "react-i18next";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
import ModalFormGenerico from "../../../components/form-generico";
import { INT_TRUE, INT_FALSE } from "../../../utils/const/int-const";
import Select from "react-select";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";

import { AgGridReact } from "ag-grid-react";
// import { ClientSideRowModelModule } from "ag-grid-community"; // Import required module
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

//import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS
//import "ag-grid-community/styles/ag-theme-alpine.css"; // Theme CSS
import "../../../style/style-ag-grid.css";

import { createProveedor, disableProveedor, enableProveedor, getListProveedor, updateProveedor } from "../../../api/api-equipment-provider";
import { COLOR_AZUL_MAIN } from "../../../utils/const/colors-const";
import { STRING_COLOR_PRIMARIO } from "../../../utils/const/string-const";

// Register the modules
ModuleRegistry.registerModules([AllCommunityModule]);

let accesoBotonNuevo = '';


export default function ListEquipmentProvider() {

  const { t } = useTranslation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  // const [listaElementos, setListaElementos] = useState([]);
  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);
  const statusOptions = SELECT_HABILITADO_DESHABILITADO.map(option => ({
    value: option.value,
    label: t(option.label), // Ensure it matches translation keys
  }));
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [showModalFormGenerico, setShowModalFormGenerico] = useState(false);
  const [formData, setFormData] = useState({});
  const [rowData, setRowData] = useState([]);
  const [primaryColor, setPrimaryColor] = useState(COLOR_AZUL_MAIN);
  const [isHovered, setIsHovered] = useState(false);
  const hoverColor = COLOR_AZUL_MAIN;

  const columnDefs = [
    {
      field: "acciones", headerName: t("column_actions"),
      cellRenderer: (params) => {
        // console.log('cellRenderer');
        // console.log(params);
        return (
          <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
            <button
              onClick={() => handleEdit(params.data)}
              style={{
                backgroundColor: "#1E90FF",
                color: "white",
                border: "none",
                padding: "5px 10px",
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              {t("label_edit")}
            </button>
            {params.data.habilitado === INT_TRUE &&
              <button
                onClick={() => handleDisable(params.data)}
                style={{
                  backgroundColor: "#DC3545",
                  color: "white",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                {t("label_disable")}
              </button>
            }
            {params.data.habilitado === INT_FALSE &&
              <button
                onClick={() => handleEnable(params.data)}
                style={{
                  backgroundColor: "#DC3545",
                  color: "white",
                  border: "none",
                  padding: "5px 10px",
                  cursor: "pointer",
                  borderRadius: "5px",
                }}
              >
                {t("label_enable")}
              </button>
            }
          </div>
        );
      }
    },
    { field: "id", headerName: "ID", hide: true },
    { field: "codigo", headerName: t("column_code"), filter: true, sortable: true, },
    { field: "descripcion", headerName: t("column_description"), filter: true, sortable: true, },
    { field: "nota", headerName: t("column_note"), filter: true, sortable: true, },
    { field: "fechamodificacion", headerName: t("column_date_modify"), filter: true, sortable: true, },
    { field: "habilitadolabel", headerName: t("column_enable"), filter: true, sortable: true, },
  ];

  useEffect(() => {
    const mainColor = localStorage.getItem(STRING_COLOR_PRIMARIO);
    if (mainColor !== null) {
      setPrimaryColor(mainColor);
    }
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      /*let obj = {};
      obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
      obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
      obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      */
      let permiso = null;
      let lista = [];

      lista = await getListProveedor(objEnviar, false, t);
      // console.log('lista');
      // console.log(lista);
      agregarAccionesALista(lista, permiso);
      setTieneAccesoAlModulo(true);
      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  };

  const agregarAccionesALista = (lista, permiso) => {
    try {
      // console.log('agregarAccionesALista');
      // console.log(lista);
      setRowData(lista);
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const handleEdit = (data) => {
    try {
      // console.log("handleEdit");
      // console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      setFormData({
        ...formData,
        id: data.id,
        codigo: data.codigo,
        descripcion: data.descripcion,
        nota: data.nota,
      });
      setShowModalFormGenerico(true);
    } catch (err) {
      console.log("handleEdit err");
      console.log(err);
    }
  };

  const handleDisable = async (data) => {
    try {
      // console.log("handleDisable");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("handleDisable err");
      console.log(err);
    }
  };

  const handleEnable = async (data) => {
    try {
      // console.log("handleEnable");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("handleEnable err");
      console.log(err);
    }
  };

  const handleAtrasClick = () => {
    history.goBack();
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleConfirmDisableCombustibleModal = async () => {
    // console.log('handleConfirmDisableCombustibleModal');
    // console.log(elementoSelected);
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      const response = await disableProveedor(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert(t("alert_disable_success"));
        reset();
        return;
      }
      if (response.error === true) {
        alert(t("alert_disable_failed") + "\n" + response.message);
      }
    }
  };

  const handleConfirmEnableCombustibleModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      const response = await enableProveedor(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        alert(t("alert_enable_success"));
        reset();
        return;
      }
      if (response.error === true) {
        alert(t("alert_enable_failed") + "\n" + response.message);
      }
    }
  };

  const onConfirmForm = async (formData) => {
    try {
      // console.log('onConfirmForm');
      // console.log(formData);
      setShowModalFormGenerico(false);
      if (formData.id === 0) {
        const resp = await createProveedor(formData);
        if (resp.error === false) {
          alert(t("alert_created_success"));
          reset();
        }
        if (resp.error === true) {
          alert(resp.message);
          return;
        }
      }
      if (formData.id !== 0) {
        const resp = await updateProveedor(formData);
        if (resp.error === false) {
          alert(t("alert_update_success"));
          reset();
        }
        if (resp.error === true) {
          alert(t("alert_failed") + "\n" + resp.message);
          return;
        }
      }
    } catch (err) {
      console.log('onConfirmForm err');
      console.log(err);
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="pt-4 px-4">
          <div className="flex justify-between">
            <label
              style={{
                fontWeight: 'bold',
              }}
            >
              {t("title_manage_equipment_provider")}
            </label>
            <div className="flex justify-center">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => {
                  setFormData({
                    ...formData,
                    id: 0,
                    codigo: "",
                    descripcion: "",
                    nota: "",
                  });
                  setShowModalFormGenerico(true);
                }}
                style={{
                  display: accesoBotonNuevo,
                }}
              >
                {t("label_new")}
              </button>
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={(handleAtrasClick)}
              >
                {t("label_back")}
              </button>
              {/* <button
                type="button"
                className={ESTILO_BOTON_LISTAR_ATRAS}
                onClick={handleAtrasClick}
              >
                <Settings />
              </button> */}
            </div>
          </div>
          <div className="flex justify-between gap-4">
            {/* Select Field (3/12 columns) */}
            <div className="w-full md:w-6/12 lg:w-3/12 xl:w-3/12">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                {t("label_status")}
              </label>
              <Select
                options={statusOptions}
                isSearchable
                isClearable
                value={habilitadoSelected}
                onChange={(event) => setHabilitadoSelected(event)}
                placeholder={t("label_select_status")}
                className="w-full"
                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
              />
            </div>

            {/* Button (3/12 columns) */}
            <div className="flex items-end">
              <button
                type="button"
                className={`${ESTILO_BOTON_MODAL_ACEPTAR} w-full`}
                style={{
                  backgroundColor: isHovered ? hoverColor : primaryColor,
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                onClick={() => reset()}
              >
                {t("label_search")}
              </button>
            </div>
          </div>

          <div
            className="ag-theme-alpine pt-4"
            style={{
              height: "512px",
              width: "100%",
              "--ag-header-background-color": `${primaryColor}`,
            }}
          >
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs}
              pagination={true}
              rowHeight={50}
            />
          </div>
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleConfirmDisableCombustibleModal}
            message={t("alert_disable_model_equipment_provider")}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleConfirmEnableCombustibleModal}
            message={t("alert_enable_model_equipment_provider")}
          />
          <ModalFormGenerico
            isOpen={showModalFormGenerico}
            onCancel={() => { setShowModalFormGenerico(false); }}
            onConfirm={onConfirmForm}
            formData={formData}
            setFormData={setFormData}
            title={t("manage_equipment_provider")}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarTipoCombustible render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
